var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7301 3.51015C13.1297 -1.17295 6.20502 -1.16715 5.60536 3.51015H1.98287C0.895177 3.631 0.915997 5.37313 2.03462 5.37313H2.91437V15.309C2.91437 16.8098 4.10461 18 5.60536 18H13.6783C15.1791 18 16.3693 16.8098 16.3693 15.309V5.32138H17.3526C18.4462 5.19987 18.4086 3.51015 17.3008 3.51015H13.7301ZM11.8671 3.51015C11.3965 1.15714 7.88721 1.15714 7.41661 3.51015H11.8671ZM14.6616 5.32138H4.72561V15.2573C4.72561 15.723 5.08786 16.137 5.55361 16.137H13.7301C14.2476 16.137 14.6098 15.723 14.6098 15.2055C14.6616 15.309 14.6616 5.32138 14.6616 5.32138ZM8.7621 7.9606V13.4978C8.7621 14.6271 7.12757 14.7259 7.00261 13.6013V8.0641C7.00261 6.92547 8.63708 6.83542 8.7621 7.9606ZM12.4363 7.9606C12.312 6.84146 10.6251 6.9136 10.6251 8.0641V13.6013C10.7501 14.7265 12.3846 14.6364 12.3846 13.4978L12.4363 7.9606Z",
    fill: "#FF4D4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashRed);
export default __webpack_public_path__ + "static/media/trash-red.6e142fa1ba04bc33040df58829d3d3d9.svg";
export { ForwardRef as ReactComponent };